import { useEffect, useRef, useState } from 'react';

/**
 * Vodorovně přejížděný pruh, který dá najevo, že pokračuje.
 *
 * Pruh pohledů i záložky detailu se na telefonu přejíždějí prstem — jenže
 * poslední pilulka prostě skončí uprostřed u hrany a nic neříká, že je kam
 * jet. Změřeno na 390 px: Dokladům mizí „K doplnění" a „Historie", Pokladně
 * „Neaktivní" a „Nastavení".
 *
 * Řeší to měkký přechod do ztracena u té hrany, za kterou ještě něco je —
 * a mizí, jakmile je pruh dojetý, aby nelhal o obsahu, který tam není.
 * Maska se kreslí přes `mask-image`, takže nepřebarví podklad (pruh leží nad
 * sklem karty i nad brandovou září).
 */
export default function PruhSPrejezdem({ children, className = '', style = null, mezera = 24 }) {
    const ref = useRef(null);
    const [okraje, setOkraje] = useState({ vlevo: false, vpravo: false });

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const zmer = () => {
            const prejezd = el.scrollWidth - el.clientWidth;
            setOkraje({
                vlevo: el.scrollLeft > 4,
                vpravo: prejezd > 4 && el.scrollLeft < prejezd - 4,
            });
        };
        zmer();
        el.addEventListener('scroll', zmer, { passive: true });
        const ro = new ResizeObserver(zmer);
        ro.observe(el);
        // Pilulky s počty dorazí až s daty — přeměřit, až se obsah změní.
        const mo = new MutationObserver(zmer);
        mo.observe(el, { childList: true, subtree: true, characterData: true });
        return () => { el.removeEventListener('scroll', zmer); ro.disconnect(); mo.disconnect(); };
    }, []);

    const maska = okraje.vlevo && okraje.vpravo
        ? `linear-gradient(90deg, transparent 0, #000 ${mezera}px, #000 calc(100% - ${mezera}px), transparent 100%)`
        : okraje.vpravo
            ? `linear-gradient(90deg, #000 calc(100% - ${mezera}px), transparent 100%)`
            : okraje.vlevo
                ? `linear-gradient(90deg, transparent 0, #000 ${mezera}px)`
                : null;

    return (
        <div ref={ref} className={className}
            style={{ ...style, ...(maska ? { maskImage: maska, WebkitMaskImage: maska } : null) }}>
            {children}
        </div>
    );
}
